// Reihenfolge der Positionen in der Bestellung (Betreiber, 02.11.2026):
// „Die noch nicht eingetroffenen Bücher sollen nach oben rutschen."
//
// Nachgeschärft (03.11.2026): „Offen" heißt für den Laden
// nicht nur „noch nicht eingetroffen", sondern auch „eingetroffen, aber
// noch nicht beim Kunden". Waren alle Titel da und zwei davon noch nicht
// verschickt, standen die zwei irgendwo in der Mitte — gleicher Rang wie
// die schon gelieferten.
//
// Gruppen, von oben nach unten:
//   0 offen       — nichts eingetroffen
//   1 teil        — teilweise eingetroffen
//   2 im Haus     — eingetroffen, aber noch nicht (vollständig) draußen;
//                   auch „bereitgelegt" zählt hierher, es liegt noch hier
//   3 erledigt    — eingetroffen und vollständig verschickt/abgeholt
//   4 vergriffen
// Ob eine Position draußen ist, rechnet der Server (`sendungsstand.
// vollstaendig`, Fallstrick 15) — hier wird es nur gelesen.
//
// Innerhalb einer Gruppe bleibt die erfasste Reihenfolge (sort_order),
// damit nichts springt. Stabil: Array.prototype.sort ist seit ES2019 stabil.
//
// Nur die Anzeige. Gespeichert wird nichts; sort_order bleibt, wie sie
// ist, und der Server liefert weiterhin nach sort_order.

type Sortierbar = { status: string; sendungsstand?: { vollstaendig: boolean } | null };

function rang(p: Sortierbar): number {
  switch (p.status) {
    case 'offen':
      return 0;
    case 'teil':
      return 1;
    case 'voll':
      return p.sendungsstand?.vollstaendig ? 3 : 2;
    case 'vergriffen':
      return 4;
    default:
      return 9;
  }
}

export function positionenSortiert<T extends Sortierbar>(positionen: readonly T[]): T[] {
  return [...positionen].sort((a, b) => rang(a) - rang(b));
}
